import { WINDOW_KEY_APP_CANCEL_TOKENS_SOURCES } from "./constants";
import { localStorageSafe, setLocalStorageItem } from "../utils/storage/storage";
import { withEtagSaving } from "./not-sorted.utils";
import { makeRequest } from "./baseApi";
import { extrasArrayFields } from "../utils/search/advanced/constants";

export const setRequestCancelTokenSource = (cancelTokenKey, cancelTokenSource) => {
  if (global.window) {
    global.window[WINDOW_KEY_APP_CANCEL_TOKENS_SOURCES] = {
      ...global.window[WINDOW_KEY_APP_CANCEL_TOKENS_SOURCES],
      [cancelTokenKey]: cancelTokenSource,
    };
  }
};

/**
 * Cancels a request, made by {makeRequest} fn with {cancelTokenKey} param.
 * @returns {boolean} indicating whether {cancelTokenKey} exists.
 */
export const cancelRequest = (cancelTokenKey) => {
  if (global.window) {
    if (global.window[WINDOW_KEY_APP_CANCEL_TOKENS_SOURCES][cancelTokenKey]) {
      global.window[WINDOW_KEY_APP_CANCEL_TOKENS_SOURCES][cancelTokenKey].cancel();
      global.window[WINDOW_KEY_APP_CANCEL_TOKENS_SOURCES][cancelTokenKey] = undefined;
      return true;
    }
  }
  return false;
};

export const withEtagCachingRequest = async (requestOptions) => {
  const TAG = "/etag";
  const eTagCacheName = requestOptions.url + TAG;
  const dataCacheName = requestOptions.url;
  const storedETag = localStorageSafe.getItem(eTagCacheName);
  const parseResponseAndError = withEtagSaving(requestOptions.parseResponse, eTagCacheName);
  const request = {
    ...requestOptions,
    headers: {
      ...requestOptions.headers,
      "if-none-match": storedETag,
    },
    parseResponse: parseResponseAndError,
    parseError: parseResponseAndError,
  };
  const data = await makeRequest(request);

  if (data.status === 304) {
    const dataFromCache = localStorageSafe.getItem(dataCacheName);
    if (dataFromCache) {
      return JSON.parse(dataFromCache);
    }
  }
  setLocalStorageItem(dataCacheName, JSON.stringify(data.value));
  return data.value;
};

export const makeParamsString = (params, isApi = false) => {
  if (!Object.keys(params).length) {
    return "";
  }
  const aParams = [];
  for (const key in params) {
    if (!params[key]) {
      continue;
    }
    const item = params[key];

    if (Array.isArray(item)) {
      // array case
      if (isApi) {
        // array api format
        for (const value of item) {
          aParams.push(`${key}=${encodeURIComponent(value)}`);
        }
      } else {
        // array app format
        const value = item.join(",");
        aParams.push(`${key}=${value}`);
      }
    } else {
      // string case
      if (extrasArrayFields.includes(key)) {
        // array serialization case
        aParams.push(`${key}=${item}`);
      } else {
        aParams.push(`${key}=${encodeURIComponent(item)}`);
      }
    }
  }
  return aParams.join("&");
};
